<template>
    <div>
        <b-modal
            v-model="showModal"
            @shown="onModalShown"
            size="lg"
            centered
            hide-footer 
        >   
            <template slot="modal-title">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag class="rounded-circle" type="warning">
                        <i class="el-icon-office-building"></i>
                    </el-tag>
                    Editar centro de distribuição
                </div>
            </template>

            <el-form 
                :model="payload"
                ref="cdEditForm"
                label-position="top"
                status-icon
            > 
                <el-row :gutter="12">
                    <!-- Codigo -->
                    <el-col :span="6">
                        <el-form-item
                            prop="codigo"
                            :rules="[
                                { required: true, message: 'O código da filial é obrigatório' },
                            ]"
                        >
                            <label>Código da filial</label>

                            <el-input-number
                                v-model="payload.codigo"
                                placeholder="Ex: 2"
                                :max="10000"
                                :controls="false"
                                :disabled="isLoading"
                            >
                            </el-input-number>
                        </el-form-item>
                    </el-col>

                    <!-- Descricao -->
                    <el-col :span="18">
                        <el-form-item 
                            prop="descricao"
                            :rules="[
                                { required: true, message: 'A descrição é obrigatória' },
                            ]"
                        >
                            <label>Descrição</label>
                            <el-input
                                v-model="payload.descricao" 
                                placeholder="Ex: Matriz"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Estados -->
                    <el-col :span="12">
                        <el-form-item
                            prop="_estado"
                            :rules="[
                                { required: true, message: 'O Estado é obrigatório', trigger: ['blur', 'change'] },
                            ]"
                        >
                            <label>Estado</label>
                            <el-select 
                                v-model="payload._estado" 
                                placeholder="Selecione um estado"
                                clearable
                                filterable
                                :disabled="isLoading"
                            >
                                <el-option
                                    v-for="uf in ufs"
                                    :key="uf.value"
                                    :label="uf.uf"
                                    :value="uf.uf"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Cidades -->
                    <el-col :span="12">
                        <el-form-item
                            prop="cidade_id"
                            :rules="[
                                { required: true, message: 'A Cidade é obrigatória', trigger: ['blur', 'change'] },
                            ]"
                        >
                            <label>Cidade</label>
                            <el-select 
                                v-model="payload.cidade_id" 
                                placeholder="Selecione uma cidade"
                                clearable
                                filterable
                                :disabled="isLoading || !payload._estado"
                            >
                                <el-option
                                    v-for="city in cities"
                                    :key="city.id"
                                    :label="city.nome"
                                    :value="city.id"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Usuario ativo -->
                    <el-col>
                        <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                <el-button :type="payload.ativo ? 'success': 'danger'" plain circle :style="{ pointerEvents: 'none' }">
                                    <i v-if="payload.ativo" class="el-icon-unlock"></i>
                                    <i v-else class="el-icon-lock"></i>
                                </el-button>
                                <h6 class="mb-0 font-weight-bold">Centro de Distribuição {{ payload.ativo ? 'Ativo' : 'Inativo' }}</h6>
                            </div>

                            <el-form-item prop="status" class="mb-0">
                                <el-switch 
                                    v-model="payload.ativo"
                                    active-text="Ativo"
                                    inactive-text="Inativo"
                                    :disabled="isLoading"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                
                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    plain
                                    :disabled="isLoading"
                                    @click="onSubmit"
                                >
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                    Salvar
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </b-modal>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form, 
        FormItem,
        CheckboxGroup,
        CheckboxButton,
        RadioGroup,
        RadioButton,
        Tag,
        Drawer,
        Avatar,
        InputNumber,
        Switch,
    } from "element-ui";

    //Api
    import { AgendaApi } from "@/api/AgendaApi";
    import { CentroDistribuicaoApi } from "@/api/CentroDistribuicaoApi";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi";

    const generalResourcesApi = new GeneralResourcesApi();
    const centroDistribuicaoApi = new CentroDistribuicaoApi();

    export default {
        data() {
            return {
                cdId: null,
                payload: {
                    codigo: null,
                    descricao: null,
                    responsavel_id: null,
                    cidade_id: null,
                    estado_id: null,
                    ativo: false,
                    _estado: null,
                },
                showModal: false,
                isLoading: false,
                ufs: [],
                cities: [],
                cd: null,
            }
        }, 
        methods: {
            async getCd() {
                try {
                    this.isLoading = true;

                    const res = await centroDistribuicaoApi.show(this.cdId);

                    this.cd = res;
                } catch (error) { 
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o evento. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async onSubmit() {
                this.$refs.cdEditForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;
                    
                    try {
                        await centroDistribuicaoApi.update(this.payload, this.cdId)

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Centro de distribuição atualizado!'
                        });
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }
                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível criar o centro de distribuição!'
                        });
                    } finally {
                        this.isLoading = false;
                        this.toggleModal();
                        this.resetForm();
                        this.$emit('updated');
                    }
                })
            },
            async getUfs() {
                try {
                    this.isLoading = true;

                    const res = await generalResourcesApi.pluckUfs();

                    this.ufs = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os estados!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async getCities() {
                try {
                    this.isLoading = true;

                    const res = await generalResourcesApi.pluckCities(this.payload._estado);

                    this.cities = res;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as cidades!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            /**Preenche o estado_id de atraves do estado selecionado */
            selectedState() {
                const state = this.ufs.filter((item) => item.uf == this.payload._estado);
                this.payload.estado_id = state[0].value;
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.cdEditForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.cdEditForm.resetFields();
            },
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
        },
        watch: {
            "payload._estado": {
                async handler (_newValue, _oldValue) {
                    if(_newValue == null || _newValue == '') {
                        this.payload.cidade_id = null;
                        return;
                    } 

                    if(_newValue == null || _newValue == '' || _newValue == _oldValue) {
                        return;
                    }

                    this.selectedState();

                    await this.getCities();
                }
            },
            "cd": {
                 handler(_newValue) {
                    this.payload = {
                        codigo: _newValue?.codigo,
                        descricao: _newValue?.descricao,
                        responsavel_id: _newValue?.responsavel_id,
                        cidade_id: _newValue?.cidade_id,
                        estado_id: _newValue?.estado_id,
                        ativo: _newValue?.ativo,
                        _estado: _newValue?.estado?.uf,
                    }
                }
            },
        },
        mounted() {
            this.getUfs();
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [CheckboxGroup.name]: CheckboxGroup,
            [CheckboxButton.name]: CheckboxButton,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Tag.name]: Tag,
            [Drawer.name]: Drawer,
            [Avatar.name]: Avatar,
            [InputNumber.name]: InputNumber,
            [Switch.name]: Switch,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/cd/CdEditModal.vue